import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";
import PaymentLinkTypeSelect from "./components/PaymentLinkTypeSelect";
import ProductsSelect from "./components/ProductsSelect";
import {
  ActionsContainer,
  Container,
  ContentContainer,
  ReOpenLinkModalButton,
  SubmitButton,
  Title,
} from "./styles";
import { FORM_FIELD, PAYMENT_LINK_TYPE, PAYMENT_METHOD } from "./constants";
import { CircularProgress, InputAdornment, TextField } from "@material-ui/core";
import UsersSelect from "./components/UsersSelect";
import PaymentMethodSelect from "./components/PaymentMethodSelect";
import CreditCardInstallmentsSelect from "./components/CreditCardInstallmentsSelect";
import useProductExtension from "./hooks/useProductExtension";
import ExtensionDaysInput from "./components/ExtensionDaysInput";
import { checkCanCreateLink } from "./utils";
import LinkInformationModal from "./components/LinkInformationModal";
import { useEffect, useState } from "react";
import * as dateFNS from 'date-fns';

export default function ProductExtension() {
  const {
    values,
    linkInformation,
    loadingSubmit,
    formErrors,
    onSubmit,
    onChangeValue,
  } = useProductExtension();
  const [showLinkInformationModal, setShowLinkInformationModal] = useState(false);

  const selectedLinkType = values[FORM_FIELD.LINK_TYPE];
  const showMaxInstallments =
    selectedLinkType === PAYMENT_LINK_TYPE.PAYMENT_LINK &&
    [PAYMENT_METHOD.ALL, PAYMENT_METHOD.CREDIT_CARD].includes(
      values[FORM_FIELD.PAYMENT_METHOD]
    );

  const canCreateLink = checkCanCreateLink(values);

  const toggleShowLinkInformationModal = () => {
    setShowLinkInformationModal(prev => !prev);
  }

  useEffect(() => {
    if(linkInformation?.link && !showLinkInformationModal) {
      toggleShowLinkInformationModal();
    }
  }, [linkInformation]);

  return (
    <Container>
      <AdminMenu />
      <ContentContainer>
        <Title>Link Extensão de Produtos</Title>
        <PaymentLinkTypeSelect
          paymentLinkTypeValue={values[FORM_FIELD.LINK_TYPE]}
          onChangePaymentLinkTypeValue={(value) =>
            onChangeValue(FORM_FIELD.LINK_TYPE, value)
          }
        />
        {selectedLinkType === PAYMENT_LINK_TYPE.PAYMENT_LINK && (
          <UsersSelect
            onChangeUser={(user) => onChangeValue(FORM_FIELD.USER_ID, user.id)}
          />
        )}
        {!!selectedLinkType && (
          <>
            <ProductsSelect
              onChangeProduct={(product) =>
                onChangeValue(FORM_FIELD.PRODUCT_ID, product.id)
              }
            />
            <ExtensionDaysInput
              extensionDays={values[FORM_FIELD.EXTENSION_DAYS]}
              isLifetime={values[FORM_FIELD.IS_LIFETIME]}
              onChangeExtensionDays={(days) =>
                onChangeValue(FORM_FIELD.EXTENSION_DAYS, days)
              }
              onChangeIsLifetime={(value) => onChangeValue(FORM_FIELD.IS_LIFETIME, value)}
              errorMessage={formErrors[FORM_FIELD.EXTENSION_DAYS]}
            />
          </>
        )}
        {selectedLinkType === PAYMENT_LINK_TYPE.PAYMENT_LINK && (
          <PaymentMethodSelect
            key={selectedLinkType}
            paymentLinkTypeValue={selectedLinkType}
            paymentMethod={values[FORM_FIELD.PAYMENT_METHOD]}
            onChangePaymentMethod={(paymentMethod) =>
              onChangeValue(FORM_FIELD.PAYMENT_METHOD, paymentMethod)
            }
          />
        )}
        {showMaxInstallments && (
          <CreditCardInstallmentsSelect
            maxInstallments={values[FORM_FIELD.MAX_INSTALLMENTS]}
            onChangeMaxInstallments={(maxInstallments) =>
              onChangeValue(FORM_FIELD.MAX_INSTALLMENTS, maxInstallments)
            }
          />
        )}
        {selectedLinkType === PAYMENT_LINK_TYPE.PAYMENT_LINK && (
          <>
            <TextField
              variant="outlined"
              label="Valor do pedido"
              placeholder="Ex: 100,00"
              value={values[FORM_FIELD.TOTAL]}
              onChange={(e) => onChangeValue(FORM_FIELD.TOTAL, e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">R$</InputAdornment>
                ),
              }}
              error={formErrors[FORM_FIELD.TOTAL]}
              helperText={formErrors[FORM_FIELD.TOTAL]}
            />
            <TextField
              variant="outlined"
              type="datetime-local"
              label="Data de validade do link"
              value={values[FORM_FIELD.EXPIRATION_DATE]}
              onChange={(e) =>
                onChangeValue(FORM_FIELD.EXPIRATION_DATE, e.target.value)
              }
              inputProps={{
                min: dateFNS.format(new Date(), 'yyyy-MM-dd HH:mm')
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </>
        )}
        {selectedLinkType === PAYMENT_LINK_TYPE.RECURRENT && (
          <>
            <TextField
              variant="outlined"
              label="Parcelas"
              placeholder="Ex: 18"
              value={values[FORM_FIELD.CYCLES]}
              error={formErrors[FORM_FIELD.CYCLES]}
              helperText={formErrors[FORM_FIELD.CYCLES]}
              onChange={(e) => onChangeValue(FORM_FIELD.CYCLES, e.target.value)}
            />
            <TextField
              variant="outlined"
              label="Valor do parcela"
              placeholder="Ex: 100,00"
              value={values[FORM_FIELD.CYCLE_PRICE]}
              error={formErrors[FORM_FIELD.CYCLE_PRICE]}
              helperText={formErrors[FORM_FIELD.CYCLE_PRICE]}
              onChange={(e) =>
                onChangeValue(FORM_FIELD.CYCLE_PRICE, e.target.value)
              }
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">R$</InputAdornment>
                ),
              }}
            />
          </>
        )}
        <ActionsContainer>
          {linkInformation?.link && (
            <ReOpenLinkModalButton onClick={toggleShowLinkInformationModal}>
              Abrir último link
            </ReOpenLinkModalButton>
          )}
          <SubmitButton
            disabled={!canCreateLink || loadingSubmit}
            onClick={onSubmit}
          >
            {loadingSubmit ? (
              <>
                Criando <CircularProgress size={16} style={{ color: "#fff" }} />
              </>
            ) : (
              "Criar Link"
            )}
          </SubmitButton>
        </ActionsContainer>
      </ContentContainer>
      <LinkInformationModal open={showLinkInformationModal} link={linkInformation?.link} onClose={toggleShowLinkInformationModal} />
    </Container>
  );
}
